import { InventoryImageDTO } from "../DTO/inventoryImageDTO";

export class StoreInventoryImagesRequest{
    public userId!: string
    public businessId! : string
    public inventoryId! : number;
    public images : InventoryImageDTO[] =[];
}